module.exports = __webpack_public_path__ + "img/boshimao.3cb7bfb2.png";